import React from 'react';

export function JSMAndCSMLogo() {
	return <>JSM and CSM Logo</>;
}
